import { classNames } from '@panwds/tailwindcss';
import React from 'react';
export function CellWrapper({ cell, last = false, children }) {
    const classes = classNames(last && 'twds-flex-grow');
    const { key, ...cellProps } = cell.getCellProps();
    return (React.createElement("div", { key: key, "data-metrics": `column-${cell.column.id}`, "data-testid": cell.column.id, "data-table-column-id": cell.column.id, className: classes, ...cellProps },
        React.createElement("div", { className: "twds-font-lato twds-box-border twds-px-4 twds-items-center twds-flex twds-h-full twds-w-full twds-leading-tight" }, children)));
}
//# sourceMappingURL=cell_wrapper.js.map